import React from 'react';

import SvgIcon from '../SvgIcon';
import type { IconProps } from '../types';

const MinusIcon: React.FC<IconProps> = ({ className, size, disabled }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    className={className}
    size={size}
    disabled={disabled}
    strokeWidth={0}
    fill="currentColor"
    stroke="currentColor"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.05469 12c0-.4142.33578-.75.75-.75H20.3047c.4142 0 .75.3358.75.75s-.3358.75-.75.75H3.80469c-.41422 0-.75-.3358-.75-.75Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </SvgIcon>
);

export default MinusIcon;
